import { GET_PAYMENT_SOURCES, convertParams, convertResult } from 'app/common/api/requests/reports/desktop_payment_sources/get'
import { defaultStateDataCurrent } from 'app/common/ui-components/filter'
import { api } from 'app/api'


const paymentSourceItems = async () => {
  const res = await api.request(GET_PAYMENT_SOURCES, {
    error: 'Не удалось получить данные источников платежей',
    convertions: {
      convertParams,
      convertResult,
    },
  })

  return [res?.map(({ ID, title }) => ({ id: ID, title })), defaultStateDataCurrent] as const
}

export default paymentSourceItems
